// Utilities for normalizing signup form data before sending to the API

export const normalizeText = (v) => (typeof v === 'string' ? v : v?.text || '');

export const normalizeEducation = (arr) => {
  if (!Array.isArray(arr)) return [];
  return arr
    .map((it) => (typeof it === 'string' ? it : it?.text || ''))
    .filter((s) => s && s !== 'Add University' && s !== 'Add Higher Education');
};

export const normalizeGender = (g) => {
  const allowed = ['male', 'female', 'other', ''];
  let val = (g || '').toString().toLowerCase();
  if (!allowed.includes(val)) val = '';
  return val;
};

export function buildSignupPayload(userData = {}) {
  return {
    fullname: userData.fullname || '',
    email: userData.email || '',
    password: userData.password || '',
    phonenumber: userData.phonenumber || '',
    country: userData.country || '',
    state: userData.state || '',
    city: userData.city || '',
    dob: userData.dob || '',
    gender: normalizeGender(userData.gender),
    imageUrl: userData.imageUrl || '',
    coverUrl: userData.coverUrl || '',
    description: normalizeText(userData.description),
    bio: normalizeText(userData.bio),
    // Keep contactNumber as a normalized text for backward compatibility with server normalizers
    contactNumber: normalizeText(userData.contactNumber),
    address:
      typeof userData.address === 'string'
        ? userData.address
        : { street: normalizeText(userData.address) },
    education: normalizeEducation(userData.education),
    isVerified: !!userData.isVerified,
    status: !!userData.status,
    latitude: userData.latitude,
    longitude: userData.longitude,
    clientIp: userData.clientIp,
  };
}

export default buildSignupPayload;
